<template>
  <div class="pos-refund-container pos_refund_fullscreen">
    <div class="pos-refund-wrapper">
      <header>E-Wallet</header>
      <button @click="callClose()" class="btn-modal-close">&times;</button>

      <!-- SECTION 1 -->
      <div
        class="d-flex justify-content-center"
        style="margin-top: 115px"
        v-if="!section_name"
      >
        <div class="col-lg-6 col-xl-4 mx-auto text-center mb-5">
          <div class="input-material mb-4">
            <b-form-input
              v-model="customerPhone"
              placeholder="Mobile Number"
              class="mb-3 whiteBC"
              type="search"
              name="customerPhoneRecharge"
              id="customerPhoneRecharge"
              ref="customerPhoneRecharge"
              focus
              tabindex="0"
            ></b-form-input>
            <label>Registered Phone Number</label>
            <VkeyboardFloat
              :ID="'customerPhoneRecharge'"
              :onClickFun="
                () => {
                  keyboardObj.KeyboardPhn = !keyboardObj.KeyboardPhn;
                }
              "
            />
            <Vkeyboard
              :inputName="'customerPhoneRecharge'"
              :showOrHide="keyboardObj.KeyboardPhn"
              :initialValue="customerPhone"
              @onChangeEvent="() => {}"
              @onKeyEnter="goToSection('addmoney')"
              @changeKeyboardInput="customerPhone = $event"
              @onClickClose="
                () => {
                  keyboardObj.KeyboardPhn = false;
                }
              "
            />
          </div>

          <div class="d-flex justify-content-center">
            <button
              v-on:click="goToSection('addmoney')"
              class="btn-blue-lg mr-3"
            >
              Add Money
            </button>
            <button
              v-on:click="goToSection('checkbalance')"
              class="btn-blue-lg"
            >
              Check Balance
            </button>
          </div>

          <div
            class="
              mt-4
              content
              d-flex
              justify-content-end
              align-items-center
              fw-500
            "
            @click.prevent.stop="goToSection('addnewCustomer')"
          >
            <span>New Customer?</span>&nbsp;&nbsp;
            <a class="add_cust_link ms-3">Add Customer Details</a>
          </div>
        </div>
      </div>

      <!-- SECTION 2  -->
      <div
        class="d-flex justify-content-center mt-5"
        v-if="section_name == 'checkbalance'"
      >
        <div class="row">
          <div class="col-8">
            <h6 class="mb-3">
              {{ $t("name") }} : {{ customer_details.cust_name || "-" }}
            </h6>
            <h6 class="mb-3">
              {{ $t("mobileno") }} : {{ customer_details.cust_mobile || "-" }}
            </h6>
            <h6 class="mb-3">
              {{ $t("emailaddress") }} :
              {{ customer_details.cust_email || "-" }}
            </h6>
          </div>
          <div class="col-4">
            <div class="d-flex justify-content-center align-items-center">
              <div class="icon-e-wallet"></div>
              <div class="e-wallet-balance">
                {{ parseFloat(wallet_balance).toFixed(this.MIN_FRACTION_DIGITS) || 0 }}
                {{ currency_code }}
              </div>
            </div>
          </div>
          <div class="col-12 d-flex justify-content-center mt-3">
            <button class="btn btn-primary w-50" @click="onCloseSection()">
              Close
            </button>
          </div>
        </div>
      </div>

      <!-- SECTION 3  -->
      <div
        class="d-flex justify-content-center mt-5"
        v-if="section_name == 'addmoney'"
      >
        <div class="row">
          <div class="col-8">
            <h6 class="mb-3">
              {{ $t("name") }} : {{ customer_details.cust_name || "-" }}
            </h6>
            <h6 class="mb-3">
              {{ $t("mobileno") }} : {{ customer_details.cust_mobile || "-" }}
            </h6>
            <h6 class="mb-3">
              {{ $t("emailaddress") }} :
              {{ customer_details.cust_email || "-" }}
            </h6>
          </div>
          <div class="col-4">
            <div class="d-flex justify-content-center align-items-center">
              <div class="icon-e-wallet"></div>
              <div class="e-wallet-balance">
                {{ parseFloat(wallet_balance).toFixed(this.MIN_FRACTION_DIGITS) || 0 }}
                {{ currency_code }}
              </div>
            </div>
          </div>
          <div class="col-12 mt-4">
            <div class="w-50 mx-auto input-material mb-4">
              <b-form-input
                v-model="inputValue"
                placeholder="Enter Amount"
                class="mb-3 whiteBC"
                type="text"
                name="walletAddAmount"
                id="walletAddAmount"
                ref="walletAddAmount"
                focus
                tabindex="0"
                v-on:keyup.enter="onPayViaWallet()"
                v-on:keydown="
                  (e) => {
                    if (
                      !/[0-9]/.test(e.key) &&
                      e.keyCode !== 8 &&
                      e.keyCode !== 190
                    ) {
                      e.preventDefault();
                    }
                  }
                "
              ></b-form-input>
              <label>Add Money</label>
              <VkeyboardFloat
                :ID="'walletAddAmount'"
                :onClickFun="
                  () => {
                    keyboardObj.keyboardMoney = !keyboardObj.keyboardMoney;
                  }
                "
              />
              <Vkeyboard
                :inputName="'walletAddAmount'"
                :showOrHide="keyboardObj.keyboardMoney"
                :initialValue="inputValue"
                @onChangeEvent="() => {}"
                @onKeyEnter="onPayViaWallet()"
                @changeKeyboardInput="inputValue = $event"
                @onClickClose="
                  () => {
                    keyboardObj.keyboardMoney = false;
                  }
                "
              />
            </div>
            <div class="d-flex justify-content-center">
              <button class="btn btn-primary w-50" @click="addMoneyToWallet()">
                Recharge
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- SECTION 4  -->
      <div
        class="d-flex justify-content-center mt-5"
        v-if="section_name == 'addnewCustomer'"
      >
        <div class="row" style="max-width: 530px">
          <div class="col-12 mb-4">
            <div class="d-flex align-items-center">
              <div class="row input-material">
                <div class="col-4">
                  <b-dropdown
                    :text="
                      new_user_details['country_code']
                        ? new_user_details['country_code']
                        : 'Code'
                    "
                    variant="dropdown-curve"
                    class="w-100 text-center mr-3"
                  >
                    <div class="px-2 pb-2">
                      <input
                        required
                        type="search"
                        placeholder="Search Code"
                        class="form-control form-control-sm"
                        v-on:keyup="onSearchCode($event.target.value)"
                        v-on:keydown="onSearchCode($event.target.value)"
                        v-on:search="onSearchCode($event.target.value)"
                        v-model="searchCode"
                        id="countryCode"
                        name="countryCode"
                        ref="countryCode"
                        @focus="onClickInputHandler('country_code')"
                      />
                    </div>
                    <b-dropdown-item
                      href="#"
                      v-for="(countrycode, countryIndex) in Countries"
                      :key="countryIndex"
                      v-on:click="onSelectHandler(countrycode)"
                      v-if="countrycode.country_mob_code != null"
                      >{{ countrycode.country_mob_code }}
                    </b-dropdown-item>
                  </b-dropdown>
                  <VkeyboardFloat
                    :ID="'countryCode'"
                    :onClickFun="
                      () => {
                        Object.keys(newUserKeyboard).map((x) => {
                          if (x == 'country_code') {
                            newUserKeyboard[x] = !newUserKeyboard[x];
                          } else {
                            newUserKeyboard[x] = false;
                          }
                        });
                      }
                    "
                  />
                  <Vkeyboard
                    :inputName="'countryCode'"
                    :showOrHide="newUserKeyboard.country_code"
                    :initialValue="searchCode"
                    @onChangeEvent="onSearchCode($event)"
                    @onPressKey="onSearchCode($event)"
                    @onKeyEnter="
                      () => {
                        newUserKeyboard.country_code = false;
                      }
                    "
                    @changeKeyboardInput="searchCode = $event"
                    @onClickClose="
                      () => {
                        newUserKeyboard.country_code = false;
                      }
                    "
                  />
                </div>
                <div class="col-8">
                  <input
                    type="number"
                    id="cust_mobile"
                    ref="cust_mobile"
                    name="cust_mobile"
                    v-model="new_user_details['cust_mobile']"
                    placeholder="Mobile Number"
                    class="mobile-number"
                    @focus="onClickInputHandler('phone')"
                    v-on:keydown="
                      (e) => {
                        if (!/[0-9]/.test(e.key) && e.keyCode !== 8) {
                          e.preventDefault();
                        }
                      }
                    "
                  />
                  <label>Mobile Number</label>
                  <VkeyboardFloat
                    :ID="'cust_mobile'"
                    :onClickFun="
                      () => {
                        Object.keys(newUserKeyboard).map((x) => {
                          if (x == 'phone') {
                            newUserKeyboard[x] = !newUserKeyboard[x];
                          } else {
                            newUserKeyboard[x] = false;
                          }
                        });
                      }
                    "
                  />
                  <Vkeyboard
                    :inputName="'cust_mobile'"
                    :showOrHide="newUserKeyboard.phone"
                    :initialValue="new_user_details['cust_mobile']"
                    @onChangeEvent="() => {}"
                    @onKeyEnter="
                      () => {
                        newUserKeyboard.phone = false;
                      }
                    "
                    @changeKeyboardInput="
                      new_user_details['cust_mobile'] = $event
                    "
                    @onClickClose="
                      () => {
                        newUserKeyboard.phone = false;
                      }
                    "
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 mb-4">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  type="email"
                  v-model="new_user_details['cust_email']"
                  id="custEmailAdd"
                  name="custEmailAdd"
                  ref="custEmailAdd"
                  placeholder="Email Address"
                  v-validate="'required|email'"
                  @focus="onClickInputHandler('email')"
                />
                <label>Email</label>
                <VkeyboardFloat
                  :ID="'custEmailAdd'"
                  :onClickFun="
                    () => {
                      Object.keys(newUserKeyboard).map((x) => {
                        if (x == 'email') {
                          newUserKeyboard[x] = !newUserKeyboard[x];
                        } else {
                          newUserKeyboard[x] = false;
                        }
                      });
                    }
                  "
                />
                <Vkeyboard
                  :inputName="'custEmailAdd'"
                  :showOrHide="newUserKeyboard.email"
                  :initialValue="new_user_details['cust_email']"
                  @onChangeEvent="() => {}"
                  @onKeyEnter="
                    () => {
                      newUserKeyboard.email = false;
                    }
                  "
                  @changeKeyboardInput="new_user_details['cust_email'] = $event"
                  @onClickClose="
                    () => {
                      newUserKeyboard.email = false;
                    }
                  "
                />
              </div>
            </div>
          </div>
          <div class="col-6 mb-4">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  type="text"
                  v-model="new_user_details['first_name']"
                  placeholder="First Name"
                  v-validate="'required'"
                  id="custfirstname"
                  name="custfirstname"
                  ref="custfirstname"
                  @focus="onClickInputHandler('first_name')"
                />
                <label>First Name</label>
                <VkeyboardFloat
                  :ID="'custfirstname'"
                  :onClickFun="
                    () => {
                      Object.keys(newUserKeyboard).map((x) => {
                        if (x == 'first_name') {
                          newUserKeyboard[x] = !newUserKeyboard[x];
                        } else {
                          newUserKeyboard[x] = false;
                        }
                      });
                    }
                  "
                />
                <Vkeyboard
                  :inputName="'custfirstname'"
                  :showOrHide="newUserKeyboard.first_name"
                  :initialValue="new_user_details['first_name']"
                  @onChangeEvent="() => {}"
                  @onKeyEnter="
                    () => {
                      newUserKeyboard.first_name = false;
                    }
                  "
                  @changeKeyboardInput="new_user_details['first_name'] = $event"
                  @onClickClose="
                    () => {
                      newUserKeyboard.first_name = false;
                    }
                  "
                />
              </div>
            </div>
          </div>
          <div class="col-6 mb-4">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  type="text"
                  v-validate="'required'"
                  v-model="new_user_details['last_name']"
                  placeholder="Last name"
                  id="custlastname"
                  name="custlastname"
                  ref="custlastname"
                  @focus="onClickInputHandler('last_name')"
                />
                <label>Last name</label>
                <VkeyboardFloat
                  :ID="'custlastname'"
                  :onClickFun="
                    () => {
                      Object.keys(newUserKeyboard).map((x) => {
                        if (x == 'last_name') {
                          newUserKeyboard[x] = !newUserKeyboard[x];
                        } else {
                          newUserKeyboard[x] = false;
                        }
                      });
                    }
                  "
                />
                <Vkeyboard
                  :inputName="'custlastname'"
                  :showOrHide="newUserKeyboard.last_name"
                  :initialValue="new_user_details['last_name']"
                  @onChangeEvent="() => {}"
                  @onKeyEnter="
                    () => {
                      newUserKeyboard.last_name = false;
                    }
                  "
                  @changeKeyboardInput="new_user_details['last_name'] = $event"
                  @onClickClose="
                    () => {
                      newUserKeyboard.last_name = false;
                    }
                  "
                />
              </div>
            </div>
          </div>
          <div class="col-12 mb-4">
            <div class="d-flex pb-2">
              <b-form-checkbox
                class="j-checkbox"
                v-model="new_user_details['is_loyality_subscribe']"
                unchecked-value="N"
                value="Y"
              ></b-form-checkbox>
              <span>{{ $t("subscribeloyality") }}</span>
            </div>
          </div>

          <div class="col-12 d-flex justify-content-center">
            <button class="btn btn-primary mr-3" @click="onAddCustomer()">
              Add Customer
            </button>
            <button class="btn btn-primary" @click="onCloseSection()">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PosCashCalculator from "@/components/Partials/posCashCalculator";
import PosService from "@/services/PosService.js";
import PosFnbService from "@/services/PosFnbService.js";
import MasterService from "@/services/MasterService.js";
import UserService from "@/services/UserService.js";
import { min } from "moment";
import { mapState, mapGetters, mapActions } from "vuex";
import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";
import ManagerAuthLogin from "@/components/Partials/AuthManagerLoginPopup";
import { generateRandomCode } from "@/helper/collection";
import _ from "lodash";
import Printd from "printd";
import { BASEURL } from "@/config/index";
import { CLIENT_NAME } from "@/helper/Role";

export default {
  props: {
    onClickHandler: { type: Function },
    onClickAddMoney: { type: Function },
    curr_code: { type: String, default: "" },
  },
  components: {
    PosCashCalculator,
    Vkeyboard,
    VkeyboardFloat,
    ManagerAuthLogin,
  },
  data() {
    return {
      section_name: "",
      customer_details: {
        wallet_balance: 0,
        cust_id: null,
        cust_email: "",
        cust_name: "",
        cust_mobile: "",
      },
      customerPhone: "",
      inputValue: 0,
      wallet_balance: 0,
      keyboardObj: {
        KeyboardPhn: false,
        keyboardMoney: false,
      },

      Countries: [],
      CodeListCopy: [],
      searchCode: "",
      newUserKeyboard: {
        phone: false,
        email: false,
        first_name: false,
        last_name: false,
        country_code: false,
      },
      CountriesMethod: {
        GET: "/admin/",
        tableName: "ms_countries",
        urlKey: "countries",
      },
      new_user_details: {
        cust_id: null,
        country_code: "966",
        cust_mobile: "",
        cust_email: "",
        first_name: "",
        last_name: "",
        is_loyality_subscribe: "N",
      },
    };
  },
  watch: {},
  computed: {
    ...mapGetters([]),
    currency_code() {
      return this.curr_code;
    },
  },
  beforeMount() {
    this.getCountriesList();
  },
  methods: {
    ...mapActions([]),
    onClickInputHandler(event) {
      if (
        Object.keys(this.newUserKeyboard).some(
          (x) => this.newUserKeyboard[x] == true
        )
      ) {
        Object.keys(this.newUserKeyboard).map((x) => {
          if (x == event) {
            this.newUserKeyboard[x] = !this.newUserKeyboard[x];
          } else {
            this.newUserKeyboard[x] = false;
          }
        });
      }
    },
    onAddCustomer() {
      let errorCount = 0;
      let errorMsg = ``;

      if (!this.new_user_details["cust_mobile"]) {
        errorCount++;
        errorMsg = `Please Enter Mobile Number.`;
      } else if (!this.new_user_details["cust_email"]) {
        errorCount++;
        errorMsg = `Please Enter Email.`;
      } else if (!this.new_user_details["first_name"]) {
        errorCount++;
        errorMsg = `Please Enter First Name.`;
      } else if (!this.new_user_details["last_name"]) {
        errorCount++;
        errorMsg = `Please Enter Last Name.`;
      } else if (!this.new_user_details["country_code"]) {
        errorCount++;
        errorMsg = `Please Select Country Code.`;
      }

      if (errorCount > 0) {
        return this.$toasted.show(errorMsg);
      } else {
        let loader = this.$loading.show();
        let tempPayload = {
          first_name: this.new_user_details.first_name,
          last_name: this.new_user_details.last_name,
          mobile_number: this.new_user_details.cust_mobile,
          is_loyality_subscribe:
            this.new_user_details.is_loyality_subscribe || "N",
          cust_email: this.new_user_details.cust_email,
          cust_id: null,
          country_mob_code: this.new_user_details.country_code,
        };
        PosService.InsertOnlyCustomerDetails(tempPayload)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              this.new_user_details.cust_id =
                data.Customer_ID && data.Customer_ID.length > 0
                  ? data.Customer_ID[0]
                  : null;
              this.customerPhone = this.new_user_details.cust_mobile;
              this.goToSection("addmoney");
            } else {
              this.$toasted.show(data.message || "Unable to add Customer.");
            }
          })
          .catch((err) => {
            console.log("Error:", err);
            this.$toasted.show("Something Went Wrong!");
          })
          .finally(() => {
            loader.hide();
          });
      }
    },
    onSelectHandler: function (value) {
      this.new_user_details["country_code"] = value.country_mob_code;
    },
    onSearchCode() {},
    onCloseSection() {
      this.section_name = "";
      this.wallet_balance = 0;
      this.customer_details = {
        wallet_balance: 0,
        cust_id: null,
        cust_email: "",
        cust_name: "",
        cust_mobile: "",
      };
    },
    addMoneyToWallet() {
      if (!this.inputValue) {
        this.$toasted.show("Please Enter Amount");
      } else if (isNaN(this.inputValue)) {
        this.$toasted.show("Please Enter Valid Amount");
      } else {
        this.$store.dispatch("GET_PAYMENT_MODES", 1);
        let payload = {
          wallet_balance: +parseFloat(
            this.customer_details.wallet_balance || 0
          ).toFixed(4),
          cust_mobile: this.customer_details.cust_mobile,
          cust_name: this.customer_details.cust_name,
          cust_id: this.customer_details.cust_id,
          cust_email: this.customer_details.cust_email,
          add_amount: this.inputValue,
        };
        this.$store.dispatch("setWalletTopUpDetails", payload);
        this.onClickAddMoney();
      }
    },
    resetData() {
      this.new_user_details = {
        cust_id: null,
        country_code: "966",
        cust_mobile: "",
        cust_email: "",
        first_name: "",
        last_name: "",
        is_loyality_subscribe: "N",
      };
      this.newUserKeyboard = {
        phone: false,
        email: false,
        first_name: false,
        last_name: false,
        country_code: false,
      };
      this.customerPhone = "";
    },
    goToSection(sectionName) {
      if (sectionName == "addnewCustomer") {
        this.section_name = sectionName;
        this.resetData();
      } else {
        if (!this.customerPhone) {
          return this.$toasted.show("Please Enter Registered Mobile");
        } else {
          let payload = {
            cust_mobile: this.customerPhone,
          };
          PosService.getWalletBalance(payload)
            .then((response) => {
              const { data } = response;
              if (data.status) {
                this.section_name = sectionName;
                this.wallet_balance = data.wallet_balance;
                if (data.hasOwnProperty("customer_details")) {
                  Object.keys(this.customer_details).map((key) => {
                    this.customer_details[key] = data.customer_details[key];
                  });
                }
              } else {
                this.$toasted.show(data.message || "Something Went Wrong!");
              }
            })
            .catch((err) => {
              console.log("Error:", err);
              this.$toasted.show("Something Went Wrong!");
            });
        }
      }
    },
    callClose: function () {
      this.onClickHandler("eWalletRecharge");
    },
    getCountriesList: function () {
      this.Countries = [];
      let body = this.getRequestBody("GET", undefined, this.CountriesMethod);
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Countries = data.Records;
            this.CodeListCopy = data.Records;

            let defaultCon = data.Records.filter((c) => {
              return c.country_mob_code == "966";
            });

            if (defaultCon.length > 0) {
              this.onSelectHandler(defaultCon[0]);
            }
          } else {
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          console.log("show error :", error);
        });
    },
    onSearchCode() {
      if (this.searchCode && this.searchCode.length > 0) {
        this.Countries = this.CodeListCopy.filter((x) => {
          if (
            x.country_mob_code &&
            x.country_mob_code
              .toLowerCase()
              .includes(this.searchCode.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Countries = this.CodeListCopy;
      }
    },
  },
};
</script>
<style>
.invalid_input {
  border: 1px solid red !important;
}

.content-fnb-refund {
  height: 500px;
  overflow: auto;
  padding-top: 20px;
}

.pos_refund_fullscreen {
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  width: 100% !important;
  z-index: 999 !important;
  height: 100% !important;
  padding: 16px !important;
  position: fixed !important;
  background-color: #fff !important;
  overflow-y: auto !important;
}

.disableRefundBtn {
  opacity: 0.5;
  pointer-events: none;
}

.fw-500 {
  font-weight: 500;
}

.add_cust_link {
  color: var(--primary) !important;
  text-decoration: underline !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/EwalletRecharge.vue